import { useEffect } from 'react';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Routing from './Routing';
import WebFont from 'webfontloader';
import 'bootstrap/dist/css/bootstrap.min.css';
import store from './redux/store';
import { Provider } from 'react-redux';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const App = () => {
    useEffect(() => {
        WebFont.load({
            google: {
                families: ['Montserrat', 'Poppins', 'Roboto', 'Open Sans', 'Lato'],
            },
        });
    }, []);

    return (
        <Provider store={store}>
            <BrowserRouter>
                <Routing />
            </BrowserRouter>
        </Provider>
    );
};

export default App;
